module.exports = __webpack_public_path__ + "static/img/028 5.e6b2aa25.jpg";